import { render, staticRenderFns } from "./Signdea.vue?vue&type=template&id=1169002f&scoped=true"
import script from "./Signdea.vue?vue&type=script&lang=js"
export * from "./Signdea.vue?vue&type=script&lang=js"
import style0 from "./Signdea.vue?vue&type=style&index=0&id=1169002f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1169002f",
  null
  
)

export default component.exports